import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { PagePathService } from '../../../../services/PagePathService'
import { Props } from './Layout'
import { ExternalUrlService } from '../../../../services/ExternalUrlService'
import { AuthService } from '../../../../services/AuthService'
import { useLoginUser } from '@/src/views/states/LoginUser'

export type Params = {
  activeMenu: Props['activeMenu']
  disabled?: boolean
}

export const useProps = ({ activeMenu, disabled }: Params): Props => {
  const loginUser = useLoginUser().loginUser

  const akvBalance = '' // TODO
  const router = useRouter()
  const onClickGameCenterManager = useCallback(
    () => router.push(PagePathService.gameCenterManager()),
    [router],
  )
  const onClickArcadeMachineManager = useCallback(
    () => router.push(PagePathService.arcadeMachineManager()),
    [router],
  )
  const onClickAkiverseWorld = useCallback(() => {
    router.push(PagePathService.akiverseWorld())
  }, [router])
  const onClickDiscord = useCallback(() => {
    window.open(ExternalUrlService.getDiscordLink())
  }, [])
  const onClickPlayerManager = useCallback(() => {
    router.push(PagePathService.playerManager())
  }, [router])
  const onClickSupportCenter = useCallback(() => {
    window.open(ExternalUrlService.getSupportCenterLink())
  }, [])
  const onClickAkvLink = useCallback(() => window.open(ExternalUrlService.getAkvLink()), [])
  const onClickLogout = async () => {
    await AuthService.logOut()
    router.push(PagePathService.login())
  }
  const onClickMyAkiverse = useCallback(() => router.push(PagePathService.myPage()), [router])

  const onClickBannerManager = useCallback(() => router.push(PagePathService.adminBanner()), [router])

  const onClickInterstitialBannerManager = useCallback(
    () => router.push(PagePathService.adminInterstitialBanner()),
    [router],
  )

  const onClickTournamentManager = useCallback(
    () => router.push(PagePathService.tournamentBanner()),
    [router],
  )

  return {
    isAdmin: !!loginUser?.isAdmin,
    akvBalance,
    onClickAkvLink,
    onClickLogout,
    onClickArcadeMachineManager,
    onClickAkiverseWorld,
    onClickDiscord,
    onClickGameCenterManager,
    onClickMyAkiverse,
    onClickPlayerManager,
    onClickSupportCenter,
    onClickBannerManager,
    onClickInterstitialBannerManager,
    onClickTournamentManager,
    activeMenu,
    disabled,
  }
}
